import React from 'react';
import queryString from 'qs';
import PropTypes from 'prop-types';
import { Redirect as ReactRouterRedirect } from 'react-router-dom';

import { log } from '../../Helpers/helpers';
import withGeoLocation from '../../Containers/withGeolocation';
import * as utils from '../../FindCare/findcare-map/helpers';

import CONSTANTS from './constants';

const RedirectWithCoords = (props) => {
  const { coords, location, geoLocationError } = props;
  let qs = queryString.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  if (coords === null) {
    if (geoLocationError) {
      delete qs.nearby;
      qs.s = CONSTANTS.SORT_NAME;
      qs.lat = '';
      qs.lng = '';
    } else {
      // while wating for geoLocation
      return null;
    }
  } else {
    qs.s = CONSTANTS.SORT_DISTANCE;
    qs.lat = coords.latitude;
    qs.lng = coords.longitude;
  }
  const url = `${location.pathname}?${queryString.stringify(qs)}`;

  log()(`Redirect to: %c${url}`, 'font-weight: bold; color: #007;', qs);
  return <ReactRouterRedirect to={url} />;
};

const RedirectToLatLng = ({ qs, location }) => {
  if (!utils.shouldRedirectToLatLng(qs)) return null;
  // Use container to access lat & lng props.
  const Redirect = withGeoLocation(RedirectWithCoords);
  return <Redirect location={location} />;
};

RedirectToLatLng.propTypes = {
  qs: PropTypes.object,
  location: PropTypes.object,
};

export default RedirectToLatLng;
